import React, { useState } from "react";

import { updateFavorite } from "@network/Profile";
import { useLocation } from "react-router-dom";
import * as S from "./style";
// import { ClockCircleIcon } from "@components/Icons";
import { routes } from "@const/routes";
import moment from "moment";
import ShareRaffle from "./ShareRaffle";
import defaultRaffleThumbnail from "@assets/img/raffle/defaultThumbnailRaffle.png";
import commingSoonImage from "@assets/img/comming-soon.svg";
import gameController from "@assets/img/game-controller.png";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SCREEN } from "@type/index";

interface RaffleProps {
  id: number;
  raffleId: number;
  title: string;
  type: string;
  status: string;
  startTime: Date;
  expiredDate: Date;
  category: string;
  numberOfTurns: number;
  numberOfParticipants: number;
  thumbnailImg: string;
  bannerImg: string;
  rn: string;
  favorite: boolean;
  screen: SCREEN;
  updateFavoriteList: (id: number) => void;
}

const RaffleItem = ({
  id,
  raffleId,
  title,
  status,
  startTime,
  expiredDate,
  numberOfTurns,
  thumbnailImg,
  favorite,
  screen,
  updateFavoriteList,
}: RaffleProps) => {
  const location = useLocation();
  const [isFavorite, setIsFavorite] = useState<boolean>(favorite);
  const isRaffleResultPage = location.pathname === routes.raffleResult;
  const [openSharePopup, setOpenSharePopup] = useState<boolean>(false);

  const handleFavorite = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await updateFavorite(raffleId);
      setIsFavorite(!isFavorite);
      updateFavoriteList(raffleId);
    } catch (err) {
      console.log(err);
    }
  };

  const appUrl = window.location.origin;
  const raffleUrl = `${appUrl}/raffle/${id}`;

  const handleShareRaffle = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    setOpenSharePopup(true);
  };
  const redirectTo = (() => {
    let redirectPage = routes.raffle;
    if (isRaffleResultPage) redirectPage = routes.raffleResult;

    return `${redirectPage}/${id}`;
  })();

  const getDynamicRaffleImage = () => {
    // Only apply this logic for Daily and Weekly raffles
    if (type?.toLowerCase() !== 'daily' && type?.toLowerCase() !== 'weekly') {
      return thumbnailImg || defaultRaffleThumbnail;
    }

    const isWeekly = type?.toLowerCase() === 'weekly';
    const referenceDate = isWeekly ? moment(expiredDate).local() : moment(startTime).local();

    const dayName = referenceDate.format('dddd').toUpperCase();
    const dayDigit = referenceDate.format('DD');
    const monthName = referenceDate.format('MMMM').toUpperCase();

    // Status mapping for image path
    const statusStr = (status || "").toString().toUpperCase();
    const isLive = statusStr === 'ELIGIBLE' || statusStr === 'HAPPENING' || statusStr === 'ACTIVE';
    const isDone = statusStr === 'DONE';

    let state = "COMING SOON";
    if (isLive) state = "LIVE";
    if (isDone) state = "END";

    return `/raffle/${dayName} ${dayDigit} ${monthName} ${state}.png`;
  };

  return (
    <>
      <S.Container to={redirectTo} key={id}>
        {screen === SCREEN.DASHBOARD && (
          <img className="coming-soon-image" src={commingSoonImage} />
        )}
        <S.Wrapper>
          <S.Image
            src={getDynamicRaffleImage()}
            alt={title}
            onError={(e) => {
              const target = e.currentTarget;
              if (target.src.includes('COMING%20SOON')) {
                target.src = target.src.replace('COMING%20SOON', 'LIVE');
              } else {
                target.src = thumbnailImg || defaultRaffleThumbnail;
                target.onerror = null;
              }
            }}
          />
          <div className="details">
            <div>
              <h1 className="truncate">{title}</h1>
              <div className="startDate">{moment(startTime).format('Do MMMM YYYY')}</div>
            </div>
            <div className="heart-icon-div">
              <button
                onClick={(e) => handleFavorite(e)}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FontAwesomeIcon
                  className="heart-icon"
                  icon={isFavorite ? faHeartSolid : faHeartRegular}
                  style={{
                    color: isFavorite ? "#e74c3c" : "black",
                  }}
                />
              </button>
            </div>
          </div>
          <S.Bottom>
            <div className="play-btn">
              <img className="game-controller" alt="image" src={gameController} /> Play Raffle
            </div>
            {/* {!isRaffleResultPage && (
              <>
                <S.Info>
                  <div>
                    <span>Next game in: </span>
                    <span><CountdownTimer time={startTime} exTime={expiredDate} /></span>
                  </div>
                </S.Info>
              </>
            )} */}
            {/* {isRaffleResultPage ? (
              <S.Info>
                <img src={Img.Clock} style={{ marginRight: 2 }} />
                <div>
                  Next Game In:{" "}
                  {<CountdownTimer time={startTime} exTime={expiredDate} />}{" "}
                  Time:{" "}
                  {moment(startTime.toString()).format(
                    RAFFLE_ITEM_DATE_TIME_FORMAT
                  )}
                </div>
              </S.Info>
            ) : (
              <div style={{position: "relative", height: 24}}>
                <S.Footer>
                  <S.Title
                    className={status === "WAITING_PEOPLE" ? "waiting" : ""}
                  >
                    {RAFFLE_STATUS[status]}
                  </S.Title>
                  <S.Info>
                    <button onClick={handleShareRaffle}>
                      <img src={Img.Share} />
                    </button>
                    <button onClick={(e) => handleFavorite(e)}>
                      {isFavorite ? (
                        <img src={Img.Heart} />
                      ) : (
                        <img src={Img.EmptyHeart} />
                      )}
                    </button>
                  </S.Info>
                </S.Footer>
              </div>
            )} */}
          </S.Bottom>
        </S.Wrapper>
      </S.Container>
      <ShareRaffle
        isOpen={openSharePopup}
        url={raffleUrl}
        setIsOpen={() => setOpenSharePopup(false)}
      />
    </>
  );
};

export default RaffleItem;
